/**
 * Created by Bart Decorte
 * Date: 14/09/2021
 * Time: 10:37
 */
import UploadPreviewListItem from './UploadPreviewListItem';

export default class UploadPreviewListItemFile extends UploadPreviewListItem {
  async renderMiniature() {

  }

  miniatureEl() {

  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreviewListItemFile.js